import _ from "lodash";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Api from "../../apis/api";
import { LoadingSpinner } from "../../utils";
import PatientCreator from "../utils/patient/new/PatientCreator";
import { Box, Stack, Typography, Paper } from "@mui/material";
import LandingPatientSelfRegister from "./LandingPatientSelfRegister";
import Logo from "../../utils/Logo";
import SuccessAndFaildCreatePatient from "./SuccessAndFaildCreatePatient";
import {toReifiedUser} from "../../auth/User";

const InvalidTokenError = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <Typography variant="h6" align="center">
        El link ingresado es inválido, por favor volvé a pedírselo a tu médico/a
      </Typography>
    </Box>
  );
};

const PatientSelfRegister = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [checkEnterData, setCheckEnterData] = useState(false);

  const api = new Api(token);

  const [user, setUser] = useState();
  const { title, name, surname } = user || { title: "", name: "", surname: "" };
  const fromDoctorByTitle = user?.patientsDisplayNames()?.preposition;
  const titlePatints = "Datos del Paciente";

  const subtitlePatints = `Complete sus datos para sumarse a la cartilla de pacientes ${fromDoctorByTitle}`;
  const messageSuccess = `Sus datos han sido enviados correctamente al recetario ${fromDoctorByTitle}`;

  const [doctorLoading, setDoctorLoading] = useState(true);
  const [creationStatus, setCreationStatus] = useState(null);
  const creationLoading = creationStatus === "loading";
  const invalidToken = !token || (!doctorLoading && _.isEmpty(user));

  useEffect(() => {
    if (!token) {
      setDoctorLoading(false);
      return;
    }
    api
      .userByToken()
      .then(user => {setUser(toReifiedUser(user))})
      .tap(() => setDoctorLoading(false))
      .catch(() => setDoctorLoading(false));
  }, []);

  const onSubmit = (patient) => {
    setCreationStatus("loading");
    api
      .createPatient(patient)
      .then(() => setCreationStatus("succeeded"))
      .catch(() => setCreationStatus("failed"));
  };

  const handreToLanding = () => {
    if (creationStatus === "failed") {
      setCreationStatus(null);
    } else {
      setCreationStatus(null);
      setCheckEnterData(false);
    }
  };

  if (doctorLoading)
    return <LoadingSpinner isLoading={doctorLoading} absolute />;

  if (invalidToken) return <InvalidTokenError />;

  if (!invalidToken)
    return (
      <>
        <Stack
          sx={{
            height: "auto",
            minHeight: "100vh",
            width: "100%",
            backgroundColor: "#EBF5FF80",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              height: "20vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Logo width={"80px"} />
          </Box>
          <Paper
            variant="outlined"
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              minHeight: "70vh",
              height: "auto",
              width: { xs: "90%", sm: "80%", md: "60%" },
              mt: 2,
              mb: 2,
            }}
          >
            {checkEnterData && creationStatus === null && (
              <PatientCreator
                onSubmit={onSubmit}
                loading={creationLoading}
                title={titlePatints}
                contactRequired
                subtitle={subtitlePatints}
              />
            )}

            {!checkEnterData && creationStatus === null && (
              <LandingPatientSelfRegister
                setCheckEnterData={setCheckEnterData}
                user={user}
              />
            )}

            {(creationStatus === "succeeded" ||
              creationStatus === "failed") && (
              <SuccessAndFaildCreatePatient
                messageSuccess={messageSuccess}
                name={name}
                surname={surname}
                creationStatus={creationStatus}
                handreToLanding={handreToLanding}
              />
            )}
          </Paper>
        </Stack>
      </>
    );
};

export default PatientSelfRegister;
